"use strict";
/**
 * @class FormError
 * @description renders an error div that's empty with no error, this will placehold the error space
 * so that we don't get jumpy forms when errors appear
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var svgs_1 = require("../../utils/svgs");
var formContextHOC_1 = require("./inputs/formContextHOC");
var FieldError = /** @class */ (function (_super) {
    __extends(FieldError, _super);
    function FieldError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FieldError.prototype.render = function () {
        var _a = this.props, fieldName = _a.fieldName, inline = _a.inline, errorId = _a.errorId, form = _a.form;
        var errorFromProps = this.props.error;
        // if inside a form and field is touched, get form context error
        var errorFromContext = form && form.getTouched(fieldName) && form.getError(fieldName);
        // give priority to form context over props. fallback to empty string to avoid DOM flickers
        var error = errorFromContext || errorFromProps || "";
        var className = classNames("oui-text-reserve oui-text-small oui-form-danger oui-margin-small-bottom", { "oui-display-inline-block oui-margin-left": inline });
        var icon = error && svgs_1.default("ErrorText");
        return (React.createElement("div", { className: className, id: errorId },
            icon,
            error));
    };
    return FieldError;
}(React.Component));
exports.default = formContextHOC_1.default(FieldError);
//# sourceMappingURL=FieldError.js.map